<template>
  <div>
    <el-dialog v-model="agreementShow" :close-on-click-modal="false" title="Tips" width="500" :show-close="false">
      <template #header>
        <div class="header">{{ agreementInfo.title }}</div>
        <div class="close_icon cursor_pointer" @click="closePopup">
          <el-icon :size="24">
            <Close />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="content">
          <div v-html="agreementInfo.content"></div>
        </div>
        <!-- <div class="bottom_box flex Flexjustify Flexalign">
          <div class="btn">我已阅读并同意协议</div>
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GjkcH5Agreement",

  data() {
    return {
      agreementShow: false,
      type: '',
      agreementInfo: {}
    };
  },

  mounted() {

  },

  methods: {
    closePopup() {
      this.agreementShow = false;
    },
    getAgreement() {
      this.$Api.login.getAgreement(this.type).then(res => {
        this.agreementInfo = res.data.data;
      })
    }
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 20px 20px 10px 10px;
  padding: 0;
  width: 786px;
  height: 530px;
  position: relative;
}

:deep(.el-dialog__header) {
  position: relative;
}

.header {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  color: #111111;
  line-height: 60px;
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
}

.dialog_content {
  .content {
    padding: 0 20px;
    font-size: 14px;
    color: #666666;
    line-height: 28px;
    height: 450px;
    overflow: auto;
  }

  .bottom_box {
    width: 100%;
    height: 79px;
    box-shadow: 0px 0px 38px 0px rgba(0, 0, 0, 0.26);
    border-radius: 0px 0px 10px 10px;
    position: absolute;
    bottom: 0;

    .btn {
      width: 174px;
      height: 36px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 18px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
    }
  }
}
</style>